import { useQuery } from '@tanstack/react-query';
import {
  LinearLambdaFetch,
  SheetsLambdaFetch,
  UsersLambdaFetch,
  LinearBuyingLambdaFetch,
  awaitJSON,
  pollS3
} from '@src/utils/fetch-utils';

export interface LogSummaryRow {
  week: string;
  company: string;
  network: string;
  avail: string;
  type?: string;
  count?: number;
  unaccepted?: number;
  plans_cost?: number;
  postlogs_spend?: number;
  bvs_spend?: number;
  prelog_spend?: number;
  status?: string;
  reconciler?: string;
}

export interface LogSummaries {
  duplicates: LogSummaryRow[];
  unaccepted: LogSummaryRow[];
  potentiallyMissing: LogSummaryRow[];
  overspend: LogSummaryRow[];
  prelogsOnly: LogSummaryRow[];
  linearReconciliationStatus: LogSummaryRow[];
}

export const ADMIN_LOG_SUMMARIES_QUERY_KEY = ['adminLogSummaries'];

export const useLogSummaries = (): ReturnType<typeof useQuery<LogSummaries>> =>
  useQuery({
    meta: { suppressGlobalError: true },
    queryKey: ADMIN_LOG_SUMMARIES_QUERY_KEY,
    queryFn: async (): Promise<LogSummaries> =>
      awaitJSON<LogSummaries>(await LinearLambdaFetch('/log_summaries'))
  });

export const updateAdServerTraffic = async (): Promise<void> => {
  await LinearBuyingLambdaFetch('/update_isci_destinations', { method: 'POST', body: {} });
};

export const clearSheetsCache = async (): Promise<void> => {
  await SheetsLambdaFetch('/clear', {
    method: 'POST',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    body: {}
  });
};

export const clearCompaniesAndUsersCache = async (): Promise<void> => {
  await UsersLambdaFetch('/clear', {
    method: 'POST',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    body: {}
  });
};

export const downloadMissingLinearTapesReport = async (): Promise<void> => {
  const { uuid } = await awaitJSON<{ uuid: string }>(
    await LinearBuyingLambdaFetch('/missing_linear_traffic')
  );
  await pollS3({
    bucket: 'bpm-cache',
    mimeType: 'text/csv',
    filename: `${uuid}.csv`,
    overloadFilename: 'linear_traffic.csv'
  });
};

export const updateLinearReconciliation = async (row: LogSummaryRow): Promise<void> => {
  await LinearLambdaFetch('/linear_reconciliation', {
    method: 'POST',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    body: [row]
  });
};
